module.exports = __webpack_public_path__ + "static/media/ic_update_payment_due_date.86f0f5a5.svg";